export const data = {
    experience: [
        {
            title:"AVISHKAR",
            // subTitle: "-competitive programming",
            description: "Achieved Top 10 in the final round of Softathlon, a competitive programming event with 400 participants.",
            date: "2024"
        },
        {
            title: "Technalytics 5.0",
            // subTitle: "",
            description: "Finalist in Technalytics 5.0 Data Analytics Competition at IIT (BHU) - Selected among 350+ teams.",
            date : "Feb 2025"
        },
        {
            title: "GOOGLE's STUDENT UPSKILLING LAUNCHPAD",
            // subTitle: "",
            description: "Completed a multi-session program focused on coding interviews, problem solving, and soft skills.",
            date : "April 2025"
        },
    ],

    education: [
        {
            title: " Motilal Nehru National Institute Of Technology,Allahabad",
            // subTitle: "",
            description: "B.Tech, Computer Science Engineering ",
            date: "2022-2026"

        },
        {
            title: "Sanjeevi Junior Collage",
            // subTitle: "",
            description: "Board of Intermediate Education, Andhra Pradesh (Intermediate)",
            date: "2020-2022",
        },
        {
            title: " Ravindra Bharathi Global School",
            // subTitle: "",
            description: "Board of Secondary Education, Andhra Pradesh (High School)",
            date: "2019-2020"
        }, 
    ],
}
